import * as _ from 'lodash';
import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../globals';
import Button from '../generic/Button';
import Card from '../generic/Card/Card';
import Flex from '../generic/Flex';
import List from '../generic/List';

const UserInfoCard: VoidFunctionComponent = () => {
  const [isCopied, setIsCopied] = useState(false);
  const keysToShow = ['id', 'username', 'email', 'joined', 'organizationId', 'permission', 'createdAt'];

  const handleCopyToClipboard = async (): Promise<void> => {
    const userInfo = Object.entries(_.pick(window.user, keysToShow))
      .map(([key, val]) => `${key}: ${(val || '').toString()}`)
      .join('\n');

    await navigator.clipboard.writeText(userInfo);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>
        <Flex direction="row" align="center" justify="space-between">
          <div>User Info</div>
          <Button onClick={handleCopyToClipboard} size="micro" type="outline">
            {isCopied ? 'Copied!' : 'Copy'}
          </Button>
        </Flex>
      </Card.Header>
      <Card.Content>
        <List isBorderless>
          <List.Body hasPadding={false}>
            {Object.entries(_.pick(window.user, keysToShow)).map(([key, val]) => (
              <List.Row
                key={key}
                hasTightPadding
                hasTightVerticalPadding
                left={<b>{key.toString()}</b>}
                right={<span>{(val || '').toString()}</span>}
              />
            ))}
          </List.Body>
        </List>
      </Card.Content>
    </Card>
  );
};

export default UserInfoCard;
